var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating",class:_vm.scoreRating},[_vm._v(" "+_vm._s(_vm.actualScore.toFixed(2))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }